import { FieldValidatorType } from "../../../enums/field-validator-type.enum";
import { IFieldValidator } from "../../../interfaces/i-field-validator";

export class MaxLengthValidator implements IFieldValidator  {
  type : FieldValidatorType  = FieldValidatorType.MaxLength;
  maxLength: number;

  constructor(init?: Partial<MaxLengthValidator>) {

    if (init) //if no values are passed in, fresh instantiation
    {
      Object.assign(this, init);
    }
  }
}
